import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const RotationsPage = async () => import('@/pages/RotationsPage.vue');
const RotationFormPage = async () => import('@/pages/RotationFormPage.vue');

export default function getRotationsRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'rotations',
      component: RotationsPage,
      meta: {
        title: 'Rotations',
        useIn: ['navigation-tabs'],
      },
      path: '/rotations',
    },
    {
      name: 'create-rotation',
      component: RotationFormPage,
      meta: {
        title: 'Create rotation',
      },
      path: '/rotations/create',
      props: (): {
        action: CrudAction;
      } => ({
        action: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      name: 'edit-rotation',
      component: RotationFormPage,
      meta: {
        title: 'Edit rotation',
      },
      path: '/rotations/edit/:id',
      props: (
        route,
      ): {
        action: CrudAction;
      } => ({
        action: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-rotation',
      component: RotationFormPage,
      meta: {
        title: 'Clone rotation',
      },
      path: '/rotations/clone/:id',
      props: (
        route,
      ): {
        action: CrudAction;
      } => ({
        action: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
